import React from 'react';
import { useState } from "react";
import styled from 'styled-components/macro';
import { TextField,Snackbar } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const DisplayFieldVertical = props => {
  const { label, value, displayChange } = props;
  const { t } = useTranslation();
  // const displayChanges = value + ' → ' + newValue;

  const [open, setOpen] = useState(false);

  const handleClick = async (value) => {
    setOpen(true);
    await navigator.clipboard.writeText(value);
  };

  return (
    <Wrapper>
      <div>
        <div>{t(label)}</div>
        <TextField
          className={`display-field ${(displayChange) && 'pending'}`}
          value={value}
          multiline
          minRows={props.minRows ?? undefined}
          variant='outlined'
          InputProps={{
            readOnly: true,
            style: { fontSize: 12 },
          }}
          inputProps={{onClick: () => handleClick(value)}}
        />
        <Snackbar
        message="Copied to clipboard"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
        open={open}
      />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: inherit;
  margin: 0 5px;
  border-radius: 5px;

  .pending {
    border-radius: 5px;
    background: ${p => p.theme.pending};
  }

  .complete {
    border-radius: 5px;
    background: ${p => p.theme.complete};
  }

  .display-border {
    border: 2px solid red;
    margin: -2px;
  }

  .display-field {
    width: 100%;
    // pointer-events: none;
  }

  .MuiOutlinedInput-root {
    padding: 5px;
  }
`;
